import { useState, useEffect } from 'react'

/**
 * Componente para renderizar iconos SVG de tipos de anomalía
 * Fetcha el SVG desde la URL y lo renderiza inline para permitir colorización
 */
const TipoAnomaliaIcon = ({ iconoUrl, color, className = 'w-5 h-5', alt = '' }) => {
  const [svgContent, setSvgContent] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(false)

  useEffect(() => {
    if (!iconoUrl) {
      setIsLoading(false)
      return
    }

    // Cache simple en memoria para evitar refetch del mismo SVG
    const cacheKey = `svg-${iconoUrl}`
    const cached = sessionStorage.getItem(cacheKey)

    if (cached) {
      setSvgContent(cached)
      setIsLoading(false)
      return
    }

    // Fetch del SVG
    fetch(iconoUrl)
      .then(response => {
        if (!response.ok) throw new Error('Failed to fetch SVG')
        return response.text()
      })
      .then(svgText => {
        // Guardar en cache
        sessionStorage.setItem(cacheKey, svgText)
        setSvgContent(svgText)
        setIsLoading(false)
      })
      .catch(() => {
        setError(true)
        setIsLoading(false)
      })
  }, [iconoUrl])

  if (isLoading) {
    return <div className={`${className} bg-gray-200 animate-pulse rounded`} />
  }

  if (error || !svgContent) {
    return null // No mostrar nada si hay error
  }

  // Renderizar SVG inline con color aplicado
  return (
    <div
      className={className}
      style={{ color: color || 'currentColor' }}
      dangerouslySetInnerHTML={{ __html: svgContent }}
      aria-label={alt}
    />
  )
}

export default TipoAnomaliaIcon
